module.exports = __webpack_public_path__ + "static/img/13.fc1ae9a8.png";